import { useState, useMemo } from "react";
import { Autocomplete, TextField, CircularProgress } from "@mui/material";
import _ from "lodash";
import axios from 'axios';
import { baseURL } from "../Constant";

const UserAutoComplete = ({onUserselect, error}) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [responseError, setResponseError] = useState("");  

  const fetchUsers = async (searchText) => {
    let token = localStorage.getItem("token");    

    try {          
      if(!token)
        throw new Error("Token not found.");

      const apiUrl = `${baseURL}/admin/users`;
      const res = await axios.post(apiUrl, {searchText}, {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        }
      });                        
         
      if(res.data.success !== true) 
        throw new Error(res.data.message);

      const usersMAilIds = (res.data.data).map((mail) => ({
          label: mail,
          value: mail,
      }))      
      setOptions(usersMAilIds);
    } catch (err) {
      console.error("Error fetching users:", err.message);      
      setResponseError("Session expired. Please reload the page.");
    } finally {
      setLoading(false);
    }
  };
  
  const debouncedSearch = useMemo(() => _.debounce((value) => {
    if (value.length >= 3) {
      setLoading(true);
      fetchUsers(value);
    } else {
      setOptions([]);
    }
  }, 300), []);

  return (
    <Autocomplete
      options={options}
      loading={loading}
      style={{padding: '0px'}}
      onInputChange={(event, newValue) => {
        debouncedSearch(newValue);
      }}
      onChange={(event,newValue) => {
        onUserselect(newValue?.value);        
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder="Search..."
          size="small"
          variant="outlined"  
          error={responseError ? responseError : error}          
          helperText={responseError ? responseError : (error ? "'Enterprise ID' is required" : "")}        
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading && <CircularProgress size={20} />}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
          sx={{
            '& .MuiOutlinedInput-root': {
              padding: '1px 1px 1px 5px'
            },
          }}
        />
      )}
    />
  );
};

export default UserAutoComplete;
